import React from 'react';
import SvgChevronRight from 'src/assets/svg/SvgChevronRight.svg';
import './render-sub-type.scss';

const RenderSubType = ({ icon, onClick, title }) => (
    <div className="sub-types-item" onClick={onClick}>
        <div className="types-item-left">
            {icon}
            <div className="types-item-left-right">
                <div className="snif-m2 snif-semibold mb-0">{title}</div>
            </div>
        </div>
        <SvgChevronRight className="types-icon-right" />
    </div>
);

export default RenderSubType;
